import { call, put } from 'redux-saga/effects';
import storage from 'utils/storage';
import AppActions from './AppRedux';
import AuthActions from './AuthRedux';
import { login } from './AuthSaga';

export function* startup() {
  yield call(storage.migrate);

  const userItem = yield call(storage.getItem, 'vemospay-user');
  const token = yield call(storage.getItem, 'vemospay-token');

  if (!userItem.value || !token.value) yield call(AuthActions.logout);

  if (userItem && userItem.value && token && token.value) {
    const user = JSON.parse(userItem.value);
    yield call(login, { token: token.value });
    yield put(AuthActions.setUser(user));
  }

  yield put(AppActions.setLoaded(true));
}
